
$('.auro-distributors a.see-more').click( function() {
  event.preventDefault()
  parent = $(this).parents('.auro-distributors').find( ".more-blurb" )
  var globo = $(this).parents('.auro-distributors').find( ".p-content" )
  $(parent).hide()
  $(globo).slideToggle()
})

$("a#recov_custom").click( function() {
  event.preventDefault()
  $("#CustomerLoginForm").addClass("hide")
  $("#RecoverPasswordForm").removeClass("hide")
})

$('.auro-distributors a.see-less').click( function() {
  event.preventDefault()
  parent = $(this).parents('.auro-distributors').find( ".more-blurb" )
  var globo = $(this).parents('.auro-distributors').find( ".p-content" )
  $(parent).show()
  $(globo).slideToggle()
})

$('.accordion-title').click( function(){
  $(this).next().slideToggle()

  if ( $(this).hasClass('is-open') ) {
      $('.accordion-title').removeClass('is-open')
  } else {
      $(this).addClass('is-open')
  }
}) 
jQuery(document).ready(function () {
    var previousActiveTabIndex = 0;

    $(".tab-switcher").on('click keypress', function (event) {
        // event.which === 13 means the "Enter" key is pressed

        if ((event.type === "keypress" && event.which === 13) || event.type === "click") {

            var tabClicked = $(this).data("tab-index");

            $(this).siblings().removeClass('active-nav')
            $(this).addClass('active-nav')
            
            if(tabClicked != previousActiveTabIndex) {
                $(".tab-container").each(function () {
                    if($(this).data("tab-index") == tabClicked) {
                        $(".tab-container").hide();
                        $(this).show();
                        previousActiveTabIndex = $(this).data("tab-index");
                        return;
                    }
                });
            }
        }
    });
});
  
  

// Dev JS
$(function(){


// handle links with @href started with '#' only
$(document).on('click', 'a[href^="#"]', function(e) {
  // target element id
  var id = $(this).attr('href');

  // target element
  var $id = $(id);
  if ($id.length === 0) {
      return;
  }

  // prevent standard hash navigation (avoid blinking in IE)
  e.preventDefault();

  // top position relative to the document
  var pos = $id.offset().top;
  if ($(window).width() <= 767) {
    var pos = $id.offset().top - 195;
  }
  else {
    var pos = $id.offset().top - 300;
  }
  // animated top scrolling
  $('body, html').animate({scrollTop: pos});
});

  $("table#recipe-table tbody tr:nth-of-type(2) td:nth-of-type(2)").remove()
  if ( !$("#app,#AppFrameMain").length ) {
    $("#shopify-section-site-locations").prependTo("#search-left-side")
  }
  function logHide() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }
    $("#CustomerLoginForm").hide()
  }
  logHide() 
  
  $('body').on('change','.bulk-tick', function(){
    if ($('.bulk-tick').prop('checked')) {
      var REDIRECT_PATH = '/pages/bulk-buyer';
      $("form#RegisterForm").submit( function(event) {
        event.preventDefault()
        var data = $(this).serialize();
        $.post('/account',data)
        .done( function(data) {
          console.log(data)
          var logErrors = $(data).find('.form-message--error').text();
          if ( logErrors != "" && logErrors != 'undefined') {
            var err = `<p class="form-row"><div class="error">Incorrect Email or password</div></p>`
            var container = $(this).find('.fixcl-scroll-content')
            $(err).prependTo(container);
          } else {
            console.log('success');

            document.location.href = REDIRECT_PATH;
          }
        }).fail( function() {
          console.log('error')
        })
        return false;
      })
    }
  })


  if (window.location.href.indexOf("collections/cacao-beans") > -1) {
    $('#boxes').remove()
  }
  if (window.location.href.indexOf("collections/all") > -1 || window.location.href.indexOf("collections/experiences") > -1 ) {
    sessionStorage.setItem('set-location','false') 
  }
  if (sessionStorage.getItem('set-location') != 'true') { 
    var id = '#boxes';
    var maskHeight = $(document).height();
    var maskWidth = $(window).width();
    $('#mask').css({'width':maskWidth,'height':maskHeight}); 
    $('#mask').fadeIn(200); 
    $('#mask').fadeTo("slow",0.5); 
    var winH = $(window).height();
    var winW = $(window).width();
    $(id).fadeIn(50);  
  } else {

  }


  $('.window .close').click(function (e) {
    // e.preventDefault();
    $('#mask').hide();
    $('#boxes').hide();
  });  
  
$('.qty button').click( function() {
  $('.sticky_atc_price').text($("p#price_ppr").text())
})
$('.qty.text').blur( function() {
  $('.sticky_atc_price').text($("p#price_ppr").text())
})
 


// $('body').on("click","#item_40f082e1-0961-4427-aabb-858b82d05fdf .sub-menu a", function() {
//   sessionStorage.setItem('set-location','false') 
// }) 
  // bind change event to select 
  var appender = window.location.href.split("/").pop()
        
  console.log(appender)
  
  if ( appender == 'butter' || appender == 'nibs' || appender == 'powder' || appender == '100-tablea' || appender == 'eat' || appender == 'bake' || appender == 'drink'  || appender == 'gifts' || appender == 'experiences' || appender == 'sale' ) {
    sessionStorage.setItem('set-location','false') 
  }

  $('#menu').on('change', function () {
    
      var link = $(this).val(); // get selected value
      if (link) { // require a URL
          
        var appender = window.location.href.split("/").pop()
        
        console.log(appender)
        
        if ( appender == 'butter' || appender == 'nibs' || appender == 'powder' || appender == '100-tablea' || appender == 'eat' || appender == 'bake' || appender == 'drink'  || appender == 'gifts' || appender == 'experiences' || appender == 'sale' ) {
          $("#shop-now").attr('href',link + '/' + appender)
        } else {
          $("#shop-now").attr('href',link)
        }


          $('.close.donate-btn').removeClass('pointer-none')
          sessionStorage.setItem('set-location','true')
          sessionStorage.setItem('location',$(link))
      }
      return false;
  });
});
if ($(window).width() >= 768) {
  $('.has-children .mega_menu_fold').hover(function(e) {
    var offset = $(this).offset().top;
    var this_height = $(this).height() + 20;
    var Y = e.pageY;
    var loc = Math.abs(offset - Y);
    if (loc > this_height) {
      $(this).parents('.has-children').removeClass('menu_item_hover')
      $(this).parents('.has-children').find('.hover-overlay').hide();
    } else {
      $(this).parents('.has-children').find('.hover-overlay').fadeIn(200)
    }

    $(this).on('mouseleave', function() {
      $(this).parents('.has-children').find('.hover-overlay').hide();
    })
  })
  $('.has-children>a').hover(function(e) {
    $(this).parents('.has-children').find('.hover-overlay').fadeIn(200); 
  })
  $('.has-children>a').on('mouseleave', function() {
    $(this).parents('.has-children').find('.hover-overlay').hide();
  })
  
  // $("body").on("hover", ".hover-overlay", function() {
  //   $(this).parents('.type_mega').removeClass(".menu_item_hover")
  // })
}


$(".cbar-btn").click(function() {
  event.preventDefault()
  $("#custom-contact").show()
  $(".accordion").hide()
  $('html, body').animate({
      scrollTop: $("#custom-contact").offset().top
  }, 2000);
});  


$(window).resize(function() {
  if ($(window).width() <= 767) {

    if ($("#focus").length > 0 ) {
      window.onload= document.getElementById("focus").focus();
    } 

    if ($('ul.cat_lv_0').length) {
      $('ul.cat_lv_0').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true
      });
    }
  }
});

if ($(window).width() <= 767) {
  
  if ($("#focus").length > 0 ) {
    window.onload= document.getElementById("focus").focus();
  }
  if ($('ul.cat_lv_0').length) {
    $('ul.cat_lv_0').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      centerMode: true,
      variableWidth: true
    });
  }
}


$(function () {
  $( "#quantity" ).change(function() {
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    if ($(this).val() > max)
    {
      $(this).val(max);
    }
    else if ($(this).val() < min)
    {
      $(this).val(min);
    }       
  }); 
});

//Rengie Custom Code
(function($){
  $(document).on('submit', 'form[action="/cart"]', function(e){
    const $this = $(this)

    var form = this,
        $form = $(form);

    e.preventDefault();

    async function testItems() {
      const result = await $.ajax({
        type: "get",
        url: "/cart.js",
        data: "data",
        dataType: "JSON"
      });
  
        const cartItem = result.items,
              specialItems = cartItem.filter(item => item.handle == 'auro-home-series-introduction-to-chocolate-tasting' || item.handle == 'auro-private-home-series-introduction-to-chocolate-tasting' || item.handle == 'auro-private-home-series-introduction-to-chocolate-tasting')
  
        let errorCount = 0
  
        if(!specialItems){
          window.location.href = `${window.location.origin}/checkout`
          // $form.attr('action', '/cart.js').off('submit').submit();
          // return true;
        } 
  
        specialItems.map(items => {
          if (items.quantity < 15){
            alert(`${items.product_title}'s quantity should have a minimum quantity of 15!`)
            errorCount++
          }
        })
  
        if(errorCount <= 0){
          window.location.href = `${window.location.origin}/checkout`
          // $form.attr('action', '/cart.js').off('submit').submit();
          // return true;
        } 
  
      return true;
    }

    testItems()

    // console.log('Submit Test')
    // console.log($this)


  })

})(jQuery)


$(document).click(function() {
    var container = $(".search_header__prs");
    if (!container.is(event.target) && !container.has(event.target).length) {
        container.hide();
    }
});